const SummaryHow2 = {
  label: 'How to Invest?',
  hide: true,
  sections: [
    {
      type: 'text',
      text: () => {
        return `
        <br />
        <h5>
            ClearTax recommends the best mutual funds to invest in<br />
            With our easy platform, you can track your growth every day<br />
            You get best results and are always worry free
        </h5>
        <br />

        <img src="https://assets1.cleartax-cdn.com/clearsave/images/process_v3.png" width="100%" />
        <br />

        <p class="light">
          Don't delay investing. Not making this decision can cost you lakhs in the future.
        </p>`;
      },
    },
  ],
};

export default SummaryHow2;



// WEBPACK FOOTER //
// ./components/recommendation/cards/summaryHow2.ts